// Auth-gated crop DB ... static list can drift if /run-anon stops accepting a UUID.

export type AcquisitionCrop = {
  id: string;
  nameKey: string;
  /** Circular list thumb. 48x48 SVG under `public/images/soilsight-pre-login/crops`, named after `nameKey`. */
  imageSrc: string | null;
};

const CROP_IMAGE_BASE = "/images/soilsight-pre-login/crops";
const cropImage = (fileName: string) => `${CROP_IMAGE_BASE}/${fileName}.svg`;

export const ACQUISITION_CROPS: AcquisitionCrop[] = [
  { id: "e03edf65-78bd-40de-b071-dff72dde253e", nameKey: "oilseed_rape", imageSrc: cropImage("oilseed_rape") },
  { id: "f92d8d76-8e33-4afb-b66a-d75120feafb7", nameKey: "winter_wheat", imageSrc: cropImage("winter_wheat") },
  { id: "5433e212-f24a-42e2-ab3b-3030bfa3816e", nameKey: "winter_barley", imageSrc: cropImage("winter_barley") },
  { id: "4f8bfe44-2103-4e70-9088-53c5ddce2008", nameKey: "spring_barley", imageSrc: cropImage("spring_barley") },
  { id: "25cfaa8f-2246-468f-bceb-1739d78d28a8", nameKey: "sunflower", imageSrc: cropImage("sunflower") },
  { id: "493e3513-88e7-49e4-8509-3843d77882b2", nameKey: "corn_grain", imageSrc: cropImage("corn_grain") },
  { id: "ee5d825e-5e7d-478e-bc93-9b762c7360ae", nameKey: "potato", imageSrc: cropImage("potato") },
  { id: "99beb3e1-2622-4ab2-9827-403c261a8b66", nameKey: "sugarbeet", imageSrc: cropImage("sugarbeet") },
  { id: "15b8a95c-6231-47e6-9022-4eafeb4e0786", nameKey: "spring_oats", imageSrc: cropImage("spring_oats") },
  // No spring wheat asset ... winter wheat is the same crop.
  { id: "693e37be-5455-4a73-a290-2fdbf4d43ebe", nameKey: "spring_wheat", imageSrc: cropImage("winter_wheat") },
  // No spelt asset ... winter wheat is the closest cereal match.
  { id: "e432d9aa-46a7-46af-ba2b-f66b38c9c4cc", nameKey: "spelt", imageSrc: cropImage("winter_wheat") },
  { id: "7153e8d4-73d7-45cd-bc12-62737e3929fe", nameKey: "soybean", imageSrc: cropImage("soybean") },
  // ‼️ Peas are disabled in the API, see: api/orm/migrations/20260519110000-disable_silver_model_practices_crop_87dd97ad.js
  // { id: "87dd97ad-de8a-4aaf-ab82-c74826f61011", nameKey: "peas", imageSrc: cropImage("peas") },
  { id: "66b9fae6-2453-47ab-bc9b-5256161a5439", nameKey: "winter_rye", imageSrc: cropImage("winter_rye") },
  { id: "bf02e1a9-8fc9-4ed0-b069-17460edb867d", nameKey: "fava_bean", imageSrc: cropImage("fava_bean") },
  { id: "b0226855-f9e7-47d0-bdd2-1b2384f5b77c", nameKey: "triticale", imageSrc: cropImage("triticale") },
  { id: "2c6893bb-8d76-4a1d-a855-85eb56c8145b", nameKey: "corn_silage", imageSrc: cropImage("corn_silage") },
];

export const ACQUISITION_CROP_BY_ID = Object.fromEntries(ACQUISITION_CROPS.map((crop) => [crop.id, crop])) as Record<string, AcquisitionCrop>;

export const cropLabelKey = (crop: AcquisitionCrop) => `preLogin.simulation.rotation.crops.${crop.nameKey}`;

export const ACQUISITION_MIN_CROPS = 1;
export const ACQUISITION_MAX_CROPS = 10;
